import React, { useState, useRef, useCallback } from "react";
import { GroupContext } from "./context";

const GroupWapper = ({ children }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogDeleteOpen, setDialogDeleteOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isDeleteMode, setIsDeleteMode] = useState(false);
  const [lastEditGroup, setLastEditGroup] = useState(null);
  const [userList, setUserList] = useState([]);

  const deleteHandlerRef = useRef(() => {});
  const registerDeleteHandler = useCallback((fn) => { deleteHandlerRef.current = fn; }, []);
  const requestDelete = useCallback((item) => deleteHandlerRef.current(item), []);

  return (
    <GroupContext.Provider
      value={{
        dialogOpen,
        setDialogOpen,
        dialogDeleteOpen,
        setDialogDeleteOpen,
        isEditMode,
        setIsEditMode,
        isDeleteMode,
        setIsDeleteMode,
        lastEditGroup,
        setLastEditGroup,
        userList,
        setUserList,
        registerDeleteHandler,
        requestDelete,
      }}
    >
      {children}
    </GroupContext.Provider>
  );
};

export default GroupWapper;
